"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpotSymbolProvider = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const constants_1 = require("../constants");
const formatter_1 = require("../formatter");
const SymbolMap_1 = require("../SymbolMap");
const SymbolProviderBase_1 = require("../SymbolProviderBase");
const SpotCacheManage_1 = require("./SpotCacheManage");
class SpotSymbolProvider extends SymbolProviderBase_1.SymbolProviderBase {
    initWithCache() {
        // 从本地缓存中读取symbol信息，赋值给变量缓存
        const LocalStorage = (0, trade_utils_lib_1.getTradeDependencyInstance)().getLocalStorage();
        return (0, rxjs_1.from)(LocalStorage.getItem(this.cacheKey)).pipe((0, operators_1.map)((data) => {
            if (data === null) {
                return;
            }
            try {
                return JSON.parse(data);
            }
            catch (e) {
                return;
            }
        }), (0, operators_1.map)((data) => {
            if (data && data.symbols) {
                SpotCacheManage_1.SpotCacheManage.updateMemoryCache(data.symbols);
                const newData = formatter_1.spotSymbolFormatter.toSymbolData(trade_utils_lib_1.ExchangeSymbolType.spot, data.symbols, false);
                this.subject.next(newData);
                return newData;
            }
            return Object.assign({}, constants_1.EmptyExchangeSymbolDataItem);
        }));
    }
    updateAndCache() {
        // 从全局变量或接口获取symbol信息，然后赋值给本地缓存
        const LocalStorage = (0, trade_utils_lib_1.getTradeDependencyInstance)().getLocalStorage();
        return (0, trade_utils_lib_1.requestWithRetry)(() => {
            return SpotCacheManage_1.SpotCacheManage.getExchangeSymbols(true);
        }, { name: "getExchangeSymbols-SpotSymbolProvider" }).pipe((0, operators_1.map)((data) => {
            const newData = formatter_1.spotSymbolFormatter.toSymbolData(trade_utils_lib_1.ExchangeSymbolType.spot, data);
            SpotCacheManage_1.SpotCacheManage.updateMemoryCache(newData.symbols);
            this.subject.next(newData);
            const storeVal = { symbols: newData.symbols };
            LocalStorage.setItem(this.cacheKey, JSON.stringify(storeVal));
            return newData;
        }), (0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)({
                symbolType: trade_utils_lib_1.ExchangeSymbolType.spot,
                symbols: [],
                map: new SymbolMap_1.SymbolMap(),
                quotes: [],
            });
        }));
    }
}
exports.SpotSymbolProvider = SpotSymbolProvider;
